module.exports = __webpack_public_path__ + "assets/img/securitiesSolutions-full.3c6c9b1b.png";